export type PortalVersion = 'v1' | 'v2'

export function initialPortalVersion(search = window.location.search): PortalVersion {
  const params = new URLSearchParams(search)
  return params.get('portal') === 'v2' ? 'v2' : 'v1'
}

export function portalQueryUrl(href: string, version: PortalVersion): string {
  const url = new URL(href)
  if (version === 'v2') {
    url.searchParams.set('portal', 'v2')
  } else {
    url.searchParams.delete('portal')
  }
  return url.toString()
}

export function syncPortalQueryParam(version: PortalVersion): void {
  window.history.replaceState({}, '', portalQueryUrl(window.location.href, version))
}

export function portalToggleClass(isActive: boolean): string {
  return isActive
    ? 'bg-white text-red-600 border-white'
    : 'bg-transparent text-white border-white/60'
}

/** Trailing slash on v2 matches portal Auth0 / Vite base contract (`/v2/`). */
export function buildIframeSrc(portalVersion: PortalVersion, billingPortalOrigin: string): string {
  return portalVersion === 'v2' ? `${billingPortalOrigin}/v2/` : billingPortalOrigin
}
